import { render, staticRenderFns } from "./MzForm.vue?vue&type=template&id=2ae80108&"
import script from "./MzForm.vue?vue&type=script&lang=js&"
export * from "./MzForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports